<template>
 <div class="article-video-preview">
    <div class="article-video-preview__header">

      <div class="article-video-preview__info">
        <h3 class="article-video-preview__name"> Видео:
          {{ videoFile.videoDescription }}
        </h3>
      </div>
    </div>

    <div class="article-video-preview__header_container" >
      <div class="article-video-preview__regalia">

                      <div class="image-wrapper">
                         <!-- The image element -->
                         <img :src="`https://navigator.eurekacenter.ru/video/${videoFile.posterName}`" alt="Placeholder Image" class="responsive-image" />

                         <!-- The button placed over the image -->
                         <button  @click="$emit('selectVideo', videoFile)" class="overlay-button">
                          {{ t("play") }}
                         </button>
                       </div>
      </div>
    </div>
  </div>


</template>

<script>


import { t } from "@/utils/translate";


export default {


  props: {
    videoFile: {
      type: Object,
      required: true,
    },
  },

  emits: ["selectVideo"],
  setup() {
    return {
      t,
    };
  },
};
</script>


<style scoped>

.article-video-preview {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin: 15px 0;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.image-wrapper {
  position: relative;
  max-width: 1920px;
}

.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}
.overlay-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* A common technique to perfectly center */

  /* Styling (optional) */
  background-color: rgba(270, 110, 130, 0.9);

  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.overlay-button:hover {
  background-color: rgba(0, 0, 0, 0.9);

}



.article-video-preview__header {
  display: flex;

  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
}

.article-video-preview__avatar-container {
  margin: 5px;
  flex-shrink: 0;
  width: 250px;
}


.article-video-preview__info {
  flex: 1;

}


.article-video-preview__name {

  font-size: 18px;
  color: #333;

}

.article-video-preview__header_container {
  border-top: 1px solid #e0e0e0;
  padding-top: 15px;
}

.article-video-preview__regalia {
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.expert-card__regalia:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.expert-card__regalia-title {
  margin: 0 0 8px 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.expert-card__regalia-body {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.expert-card__regalia-body :deep(p) {
  margin: 0 0 10px 0;
}

.expert-card__regalia-body :deep(p:last-child) {
  margin-bottom: 0;
}
</style>
